import React, { Component } from "react";
import $ from "jquery";

import Slider from "react-slick";
import SlickArrow from "./SlickArrow";

import forwardArrow from "images/forward-arrow.svg";
import backArrow from "images/back-arrow.svg";
import { Column, Row } from "react-foundation";

import "css/SlickSlider.css";

class SlickSlider extends Component {
    componentDidUpdate() {
        if (this.props.selectedId && this.slider) {
            let indexOfId = this.props.values.map(v => v.id).indexOf(this.props.selectedId);
            this.slider.slickGoTo(indexOfId);
        }
    }

    render() {
        var { values, settings, onChange, selectedId, onDisplay } = this.props;

        // set a no-op for onchange if we don't have one
        onChange = onChange || (() => {});

        if (!settings) settings = {};

        settings.dots = settings.dots || false;
        settings.slidesToShow = settings.slidesToShow || 3;
        settings.centerMode = settings.centerMode || true;
        settings.centerPadding = settings.centerPadding || "0px";
        settings.focusOnSelect = settings.focusOnSelect || true;
        settings.infinite = settings.infinite || true;
        settings.adaptiveHeight = settings.adaptiveHeight || false;
        settings.nextArrow = settings.nextArrow || <SlickArrow src={forwardArrow} />;
        settings.prevArrow = settings.prevArrow || <SlickArrow src={backArrow} />;

        let smallResponsiveSettings = {
            breakpoint: 639,
            settings: {
                slidesToShow: 1,
                centerPadding: "60px",
                nextArrow: <SlickArrow src={forwardArrow} otherClassName="small-fading" />,
                prevArrow: <SlickArrow src={backArrow} otherClassName="small-fading" />
            }
        };

        settings.responsive = settings.responsive || [smallResponsiveSettings];

        settings.afterChange = index => {
            onChange(values[index].id);
        };

        if (
            settings.slidesToShow === 5 &&
            (values.length === 1 && window.Foundation.MediaQuery.current === "small")
        ) {
            return (
                <Row className="SlickSlider">
                    <Column
                        className={
                            "slick-slide slick-fake" +
                            (selectedId === values[0].id ? " slick-center" : "")
                        }
                        key={0}
                        small={8}
                        centerOnSmall
                        onClick={() => onChange(values[0].id)}
                    >
                        {onDisplay(values[0], 0)}
                    </Column>
                </Row>
            );
        }

        if (
            settings.slidesToShow === 3 &&
            (values.length <= 1 ||
                (window.Foundation.MediaQuery.atLeast("medium") && values.length <= 3))
        ) {
            return (
                <Row className="SlickSlider">
                    {values.map((value, index) => {
                        return (
                            <Column
                                className={
                                    "slick-slide slick-fake" +
                                    (selectedId === value.id ? " slick-center" : "")
                                }
                                key={index}
                                small={12 / values.length}
                                isLast
                                onClick={() => onChange(value.id)}
                            >
                                {onDisplay(value, index)}
                            </Column>
                        );
                    })}
                </Row>
            );
        }

        if (
            settings.slidesToShow === 5 &&
            values.length <= 5 &&
            window.Foundation.MediaQuery.atLeast("medium")
        ) {
            return (
                <Row className="SlickSlider">
                    {<Column small={5 - values.length + 1}>&nbsp;</Column>}
                    {values.map((value, index) => {
                        return (
                            <Column
                                className={
                                    "slick-slide slick-fake" +
                                    (selectedId === value.id ? " slick-center" : "")
                                }
                                key={index}
                                small={2}
                                isLast
                                onClick={() => onChange(value.id)}
                            >
                                {onDisplay(value, index)}
                            </Column>
                        );
                    })}
                </Row>
            );
        }


        return (
            <Slider
                className="row columns SlickSlider"
                ref={slider => (this.slider = slider)}
                {...settings}
            >
                {$.map(values, (value, index) => {
                    let firstAndNoSelectedId = index === 0 && !selectedId;
                    return (
                        <div
                            key={index}
                            className={selectedId ? "" : "no-selection"}
                            onClick={() => (firstAndNoSelectedId ? onChange(value.id) : null)}
                        >
                            {onDisplay(values[index], index)}
                        </div>
                    );
                })}
            </Slider>
        );
    }
}

export default SlickSlider;



// WEBPACK FOOTER //
// ./src/components/SlickSlider.js